import { ZenithCookies } from "./ZenithCookies";
import { UserDetailsContextHookType } from "@zenith/context/global-context/types";
import { jwtDecode } from "jwt-decode";
import { DecodedJWT, UserRole } from "@zenith/types";
import { ACCESS } from "@zenith/data/constants";

export const handleTokenStore = (
  name: string,
  accessToken: string,
  expiresIn: number
) => {
  const TOKEN_DATE = new Date();
  TOKEN_DATE.setSeconds(TOKEN_DATE.getSeconds() + expiresIn);
  sessionStorage.setItem(name, accessToken);
  sessionStorage.setItem(`${name}_expires`, TOKEN_DATE.toISOString());
};

export const decodeAndStoreToken = (
  token: string,
  store: UserDetailsContextHookType
) => {
  const { setUserDetailsContext } = store;
  const decodedToken = jwtDecode<DecodedJWT>(token);
  setUserDetailsContext({
    id: decodedToken?.["zenz_data"]?.["user_id"] ?? "",
    role: decodedToken?.["profile"] ?? UserRole.ADMINISTRATOR,
  });
};

/**
 * The claims of the stored access token, or undefined when there is none to
 * read. The role is read from here rather than from the global context because
 * that context starts at its EMPLOYEE default, which is not an answer a gate
 * can act on until a request has decoded the token.
 */
export const getAccessTokenClaims = (): DecodedJWT | undefined => {
  const token = sessionStorage.getItem(ACCESS);
  if (!token) return undefined;

  try {
    return jwtDecode<DecodedJWT>(token);
  } catch {
    return undefined;
  }
};
